module.exports = {
  TheNotYourCustomerSelect: 'Đơn vị ủy thác này không thuộc khách hàng của bạn, vui lòng chọn lại!',
  YourAuthorityIsInsufficient: 'Bạn không có đủ quyền hạn.',
  SailingSchedule2: 'Lịch tàu 2:',
  Voyage: 'Hành trình:',
  OverweightDescription: 'Giải thích quá tải:',
  LowestPrice: 'Giá thấp nhất',
  SailingSchedule: 'Lịch tàu:',
  FullContainerFreightSharingDetails: 'Chi tiết chia sẻ giá vận chuyển container đầy',
  FullContainerFCLFreight: 'Giá vận chuyển container đầy (FCL)',
  LessContainerLoadLCLFreight: 'Giá vận chuyển hàng lẻ (LCL)',
  AirCargoAIRFreight: 'Giá vận chuyển hàng không (AIR)',
  All: 'Tất cả',
  Code: 'Mã',
  ChineseName: 'Tên tiếng Trung',
  EnglishName: 'Tên tiếng Anh',
  Country: 'Quốc gia',
  Region: 'Khu vực',
  AirFreightSurchargeDetails: 'Chi tiết phụ phí hàng không',
  Empty: 'Trống',
  LCLDestinationPortChargesDetails: 'Chi tiết phí cảng đích hàng lẻ',
  AirCargoRateDetails: 'Chi tiết giá vận chuyển hàng không',
  SecondTransit: 'Chuyển tiếp 2',
  SecondLegAircraftType: 'Loại máy bay chặng 2',
  SecondLegFlightSchedule: 'Thời gian chuyến bay chặng 2',
  SecondScheduleCannotBeEmpty: 'Thời gian chuyến bay chặng 2 không được để trống.',
  ProgramSettings: 'Thiết lập phương án',
  FullContainerFreightDetails: 'Chi tiết giá vận chuyển container đầy',
  EuropeAndAmericaLinesDedicated: 'Dành riêng cho tuyến Âu Mỹ',
  EmailCannotBeEmpty: 'Email không được để trống',
  EmailFormatError: 'Định dạng email sai',
  DestinationAreaError: 'Khu vực đích sai!',
  ContinueImporting: ', có tiếp tục nhập không?',
  FullContainerAddonFreightDetails: 'Chi tiết giá Addon container đầy',
  FullContainerAdditionalInformationDetails: 'Chi tiết thông tin bổ sung container đầy',
  LCLFreightDetails: 'Chi tiết giá vận chuyển hàng lẻ',
  CostPrice: 'Giá thành',
  PeerPrice: 'Giá đồng nghiệp',
  DirectCustomerPrice: 'Giá khách trực tiếp',
  MarketPrice: 'Giá thị trường',
  LCLAddonFreightDetails: 'Chi tiết giá Addon hàng lẻ',
  YourPermissionIsNotEnough: 'Bạn không có đủ quyền hạn.',
  SailingTime: 'Hành trình:',
  FCL: 'Container đầy',
  LCL: 'Hàng lẻ',
  FreightNumber: 'Mã giá vận chuyển:',
  CabinStatus: 'Tình trạng khoang:',
  OurDumpingOfContainersOK: 'Công ty chúng tôi không thể đảm bảo không bỏ container nếu dự kiến OK',
  NoteAdditionalChargesWithBackground: 'Ghi chú: Giá ALL IN đã bao gồm các khoản phí có nền màu xám trong phụ phí.',
  Booking: 'Đặt chỗ',
  ThisFareHasExpired: 'Giá vận chuyển này đã hết hạn!',
  NoFreightThatMeetsParty: 'Không tìm thấy ngày khởi hành phù hợp với yêu cầu lịch tàu trong thời hạn hiệu lực của giá cước, vui lòng liên hệ với bên đặt chỗ để xác nhận!',
  Subscribe: 'Đăng ký nhận tin',
  SetEmailToReceiveInformation: 'Thiết lập email nhận thông tin đăng ký',
  TheEmailCannotBeEmpty: 'Email không được để trống',
  SetCompanyToReceiveInformation: 'Thiết lập (chi nhánh) công ty nhận thông tin đăng ký',
  SetYouWantToTo: 'Thiết lập đối tác cần đăng ký',
  AdvancedSettings: 'Cài đặt nâng cao',
  SubscriptionType: 'Loại đăng ký',
  PlaceOfDeparture: 'Điểm đi',
  DischargePort: 'Điểm dỡ hàng',
  Airline: 'Hãng hàng không',
  ShippingCompany: 'Hãng tàu',
  Confirm: 'Xác nhận',
  Reset: 'Đặt lại',
  Refresh: 'Làm mới',
  Cancel: 'Hủy bỏ',
  PleaseYouWillReceiveUpdated: 'Vui lòng đăng ký thông tin bạn quan tâm, bạn sẽ nhận được email thông báo khi giá cước được cập nhật.',
  Add: 'Thêm mới',
  Edit: 'Chỉnh sửa',
  Delete: 'Xóa',
  GoBack: 'Quay lại',
  Save: 'Lưu',
  SubCompany: 'Chi nhánh',
  DeparturePort: 'Cảng đi',
  DepartureCountry: 'Quốc gia đi',
  DepartureArea: 'Khu vực đi',
  DestinationPort: 'Cảng đến',
  DestinationCountryRegion: 'Quốc gia/vùng lãnh thổ đến',
  DestinationArea: 'Khu vực đến',
  FCLWeightLimitInformationDetails: 'Chi tiết thông tin giới hạn trọng lượng hàng nguyên container',
  PleaseTheEntrustedContainerVolume: 'Vui lòng nhập số lượng container ủy thác!',
  TheBelongToYourSelect: 'Đơn vị ủy thác này không thuộc khách hàng của bạn, vui lòng chọn lại!',
  ExternalUser: 'Người dùng bên ngoài',
  FCLSailingScheduleManagement: 'Quản lý lịch tàu hàng nguyên container',
  ConfigSurchargeFcl: 'Cấu hình phụ phí',
  FCLAdditionalFeeMaintenance: 'Bảo trì phụ phí hàng nguyên container',
  HsCode: 'Mã HS',
  UnNo: 'Số UN'
}
